// Qorong'i rejim — SHAXSIY (brauzerga xos) ko'rish afzalligi, tashkilot
// brand rangidan (theme.js) MUSTAQIL. <html data-theme="dark|light"> atributi
// orqali ishlaydi — index.css'dagi :root[data-theme="dark"] bloki
// --s-*/--ink-* CSS o'zgaruvchilarini almashtiradi, shuning uchun bu yerda
// hech qanday rang hisob-kitobi yo'q, faqat atribut qo'yish/o'chirish.
//
// public/index.html'dagi inline skript ilova yuklanishidan OLDIN xuddi shu
// mantiqni takrorlaydi (localStorage/prefers-color-scheme) — aks holda
// birinchi render doim yorug' bo'lib, keyin qorong'iga "miltillab" o'tib
// ketardi (FOUC). Ikkala joyni ham o'zgartirsangiz — bir-biriga mos saqlang.

const KEY = 'erpline-theme'; // 'light' | 'dark'

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'dark' || v === 'light' ? v : null;
  } catch { return null; }
}

// Joriy amaldagi tema — localStorage'dagi aniq tanlov, aks holda DEFAULT
// har doim 'light' (OS/tizim sozlamasiga qaralmaydi — hamma uchun bir xil
// boshlang'ich holat, faqat qo'lda o'zgartirilgach saqlanadi).
export function resolveTheme() {
  return getStoredTheme() || 'light';
}

function applyAttr(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

// Ilova yuklanganda bir marta chaqiriladi — joriy temani <html>ga qo'yadi.
export function initTheme() {
  const theme = resolveTheme();
  applyAttr(theme);
  return theme;
}

// Foydalanuvchi qo'lda tanlaganda (masalan TopBar tugmasi) — saqlaydi va qo'llaydi.
export function setTheme(theme) {
  try { localStorage.setItem(KEY, theme); } catch {}
  applyAttr(theme);
}

export function toggleTheme() {
  const next = resolveTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}
